class FeraDropTimer extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.deadline);
    this.frame = requestAnimationFrame(() => {
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    });
  }
  tick() {
    const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
    const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
    for (const [key, value] of Object.entries(values)) {
      const node = this.querySelector('[data-time="' + key + '"]');
      if (node) node.textContent = String(value).padStart(2, '0');
    }
    if (!remaining) {
      clearInterval(this.interval);
      const label = this.querySelector('.fera-drop-timer__label');
      if (label) label.textContent = 'EXCLUSIVE DROP ENDED';
    }
  }
  disconnectedCallback() { cancelAnimationFrame(this.frame); clearInterval(this.interval); }
}
if (!customElements.get('fera-drop-timer')) customElements.define('fera-drop-timer', FeraDropTimer);
